/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Button, Popover } from 'react-bootstrap';
import { v4 as uuid } from 'uuid';

function TooltipButton({
  placement = '',
  children,
  trigger,
  show,
  defaultShow,
  text,
  popoverProps,
  rootClose,
  id,
  ...rest
}) {
  return (
    <OverlayTrigger
      defaultShow={defaultShow}
      show={show}
      placement={placement || 'auto'}
      trigger={trigger}
      rootClose={rootClose || false}
      overlay={
        <Popover {...popoverProps}>
          <Popover.Body>{text}</Popover.Body>
        </Popover>
      }
    >
      <Button id={id || uuid()} {...rest}>
        {children}
      </Button>
    </OverlayTrigger>
  );
}

TooltipButton.propTypes = {
  /**
   * The text of the tooltip.
   */
  // eslint-disable-next-line react/forbid-prop-types
  text: PropTypes.any.isRequired,
  /**
   * The placement of the tooltip.
   */
  placement: PropTypes.string,
};

export default TooltipButton;
